import { useState } from "react";
import { Link } from "react-router-dom";
import { supabase } from "../utils/supabase";
import AuthLayout from "../components/AuthLayout";

function SignupPage() {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const handleSignup = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    const { error: authError } = await supabase.auth.signUp({
      email,
      password,
      options: {
        data: { full_name: fullName },
      },
    });

    if (authError) {
      setError(authError.message);
      setLoading(false);
    } else {
      setSuccess(true);
      setLoading(false);
    }
  };

  if (success) {
    return (
      <AuthLayout>
        <h1
          className="text-text-primary text-[28px] mb-2"
          style={{ fontWeight: 700 }}
        >
          Check your email
        </h1>
        <p
          className="text-[#b0b0b0] text-[13px] mb-8"
          style={{ fontWeight: 500 }}
        >
          A confirmation email has been sent to{" "}
          <span className="text-text-primary">{email}</span>. Please check your
          inbox and click the confirmation link to complete your signup.
        </p>
        <Link
          to="/login"
          className="block text-center text-[11px] uppercase tracking-[3px] py-3 border border-[#b0b0b0] text-[#b0b0b0] hover:bg-[#b0b0b0] hover:text-black transition-all"
          style={{ fontWeight: 700 }}
        >
          Back to Login
        </Link>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout>
      <h1
        className="text-text-primary text-[28px] mb-2"
        style={{ fontWeight: 700 }}
      >
        Create an Account
      </h1>
      <p
        className="text-[#b0b0b0] text-[13px] mb-8"
        style={{ fontWeight: 500 }}
      >
        Activate your CreatorOS
      </p>

      <form onSubmit={handleSignup}>
        <label
          className="block text-[#888] text-[10px] uppercase tracking-[3px] mb-2"
          style={{ fontWeight: 600 }}
        >
          Full Name
        </label>
        <input
          type="text"
          value={fullName}
          onChange={(e) => setFullName(e.target.value)}
          required
          className="w-full bg-[#0a0a0a] border border-[#333] text-white text-[14px] px-4 py-3 mb-5 outline-none transition-colors focus:border-[#FF6B00]"
          style={{ fontFamily: "Space Grotesk", fontWeight: 500 }}
        />

        <label
          className="block text-[#888] text-[10px] uppercase tracking-[3px] mb-2"
          style={{ fontWeight: 600 }}
        >
          Email
        </label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="w-full bg-[#0a0a0a] border border-[#333] text-white text-[14px] px-4 py-3 mb-5 outline-none transition-colors focus:border-[#FF6B00]"
          style={{ fontFamily: "Space Grotesk", fontWeight: 500 }}
        />

        <label
          className="block text-[#888] text-[10px] uppercase tracking-[3px] mb-2"
          style={{ fontWeight: 600 }}
        >
          Password
        </label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          minLength={6}
          className="w-full bg-[#0a0a0a] border border-[#333] text-white text-[14px] px-4 py-3 mb-6 outline-none transition-colors focus:border-[#FF6B00]"
          style={{ fontFamily: "Space Grotesk", fontWeight: 500 }}
        />

        {error && (
          <p
            className="text-[#f87171] text-[12px] mb-4"
            style={{ fontWeight: 500 }}
          >
            {error}
          </p>
        )}

        <button
          type="submit"
          disabled={loading}
          className="w-full text-[11px] uppercase tracking-[3px] py-3 transition-all duration-200"
          style={{
            backgroundColor: "#FF6B00",
            color: "#000",
            fontWeight: "700",
            opacity: loading ? 0.6 : 1,
            cursor: loading ? "not-allowed" : "pointer",
          }}
        >
          {loading ? "Creating Account..." : "Create Account"}
        </button>
      </form>

      <div className="border-t border-[#222] my-8"></div>

      <p
        className="text-[#888] text-[12px] text-center"
        style={{ fontWeight: 500 }}
      >
        Already have an account?{" "}
        <Link
          to="/login"
          className="text-[#b0b0b0] hover:text-[#FF6B00] transition-colors"
          style={{ fontWeight: 600 }}
        >
          Log In
        </Link>
      </p>
    </AuthLayout>
  );
}

export default SignupPage;
